/**
 * Centralized query keys for Needs feature
 * All files in this feature should import and use these constants
 * instead of hardcoding query key strings.
 */

export const NEED_NOTES_QUERY_KEY = 'need-notes';
export const NEED_QUERY_KEY = 'need';
export const STAFFING_NEEDS_LIST_QUERY_KEY = 'staffingNeeds';
